export const nicepayClientId = (window.AMZ_ENV?.VITE_PG_NICEPAY_CLIENT_ID ?? "") as string;
